import { getFormattedEquipmentTypes } from "../../requests/type-requests";
import {AssetType, AssetTypeLabel} from "../constants/securspace-constants";

const getHeaderCells = (assetType) => {
    const headerCells = [
        { id: 'checkInDate', label: 'Check In' },
        { id: 'containerNumber', label: 'Container' },
        { id: 'trailerNumber', label: 'Trailer' },
        { id: 'chassisNumber', label: 'Chassis' },
        { id: 'orderNumber', label: 'Booking' },
        { id: 'locationName', label: 'Location' },
        { id: 'chassisLicensePlateNumber', label: 'Chassis License Plate' },
        { id: 'assetSize', label: 'Size' },
        { id: 'sealNumber', label: 'Seal' },
        { id: 'assetType', label: 'Type' },
        { id: 'supplierName', label: 'Supplier' },
        { id: 'driverName', label: 'Driver'},
        { id: 'scacCode', label: 'Scac Code' },
        { id: 'notes', label: 'Notes' },
    ];

    if ([AssetTypeLabel[AssetType.TRUCK_ONLY], AssetTypeLabel[AssetType.TRUCK_ONLY_25]].includes(assetType)) {
        headerCells.splice(5, 0, { id: 'truckLicensePlateNumber', label: 'Truck License Plate Number' });
    }

    return headerCells;
};

const sortByOptions = [
    {label: 'Check In Date', value: 'CHECK_IN_DATE'},
    {label: 'Location', value: 'LOCATION_NAME'},
    {label: 'Supplier', value: 'SUPPLIER_NAME'},
    {label: 'Equipment Type', value: 'ASSET_TYPE'},
    {label: 'Booking Number', value: 'ORDER_NUMBER'},
    {label: 'Driver First Name', value: 'DRIVER_FIRST_NAME'},
    {label: 'Driver Last Name', value: 'DRIVER_LAST_NAME'},
    {label: 'Container Number', value: 'CONTAINER_NUMBER'},
    {label: 'Trailer Number', value: 'TRAILER_NUMBER'},
    {label: 'Chassis Number', value: 'CHASSIS_NUMBER'},
    {label: 'Truck License Plate Number', value: 'TRUCK_LICENSE_PLATE_NUMBER'}
];

export const assetTypeOption = [
    {
        value: "All",
        label: "All"
    },
    {
        value:"Container/Chassis (20'/40'/45')",
        label:"Container/Chassis (20'/40'/45')"
    },
    {
        value:"Container/Chassis (40'/45'/53')",
        label:"Container/Chassis (40'/45'/53')"
    },
    {
        value:"Container/Chassis (20'/40')",
        label:"Container/Chassis (20'/40')"
    },
    {
        value:"Container/Chassis (45')",
        label:"Container/Chassis (45')"
    },
    {
        value:"Truck + Container/Chassis",
        label:"Truck + Container/Chassis"
    },
    {
        value:"Truck + Trailer",
        label:"Truck + Trailer"
    },
    {
        value:"Truck Only",
        label:"Truck Only"
    },
    {
        value:"Truck Only (25')",
        label:"Truck Only (25')"
    },
    {
        value:"Trailer (53')",
        label:"Trailer (53')"
    },
    {
        value:"Refrigerated Plug In",
        label:"Refrigerated Plug In"
    },
    {
        value:"Equipment Moving Fee",
        label:"Equipment Moving Fee"
    },
    {
        value:"Gate Fees",
        label:"Gate Fees"
    },
    {
        value:"Grounded Container",
        label:"Grounded Container"
    },
    {
        value:"Lift Fees",
        label:"Lift Fees"
    },
    {
        value:"Overage Spaces",
        label:"Overage Spaces"
    },
    {
        value:"Reefer KW Usage",
        label:"Reefer KW Usage"
    }
]


const filterBySelectOption = (snackbarShowMessage) => [
    {
        label: "Equipment",
        value: "",
        name: "equipment",
        option: getFormattedEquipmentTypes(snackbarShowMessage)
    },
];

export {
    getHeaderCells,
    sortByOptions,
    filterBySelectOption
}
